import NextLink from 'next/link';
import { memo, useEffect, useState } from 'react';
import { Button, Text, VStack, Stack, Link, Flex } from '@chakra-ui/react';

import { setCookie, getCookieOptions } from 'shared/lib';
import Wrapper from 'shared/Wrapper';

import { CONSENT_COOKIE_NAME, DEFAULT_BORDER } from 'constants/global';

const Cookies = () => {
  const [isVisible, setIsVisible] = useState(false);

  const acceptCookies = () => {
    setCookie(
      CONSENT_COOKIE_NAME,
      JSON.stringify({ ad_storage: true, analytics_storage: true }),
      getCookieOptions(),
    );
  };

  const onAccept = () => {
    if (isVisible) {
      localStorage.setItem('banner', 'seen');
      setIsVisible(false);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem('banner')) {
      acceptCookies();
      setIsVisible(true);
    }
  }, []);

  return (
    isVisible && (
      <Flex
        w="100vw"
        pos="fixed"
        bottom="0"
        left="0"
        py={{ mobile: '10px', tablet: '20px' }}
        align="center"
        justify="center"
        bgColor="bg.white"
        borderTop={DEFAULT_BORDER}
        borderColor="text.black"
        zIndex="1000"
      >
        <Wrapper pb="0" pt="0" mt="0">
          <Stack
            w="full"
            direction={{ mobile: 'column', tablet: 'row' }}
            gap={{ laptop: '40px', tablet: '20px', mobile: '10px' }}
            justify="space-between"
            align="center"
          >
            <VStack gap="8px" align="start" textAlign="start">
              <Text textStyle="h2">
                Продолжая пользоваться сайтом, вы соглашаетесь с нашей{' '}
                <Link as={NextLink} href="/cookies" isExternal>
                  Политикой использования cookie файлов.
                </Link>
              </Text>

              <Text textStyle="h2">
                Чтобы узнать больше о том, как мы обрабатываем ваши личные данные, ознакомьтесь
                с нашей{' '}
                <Link as={NextLink} href="/confidentiality" isExternal>
                  Политикой конфиденциальности
                </Link>
              </Text>
            </VStack>

            <Button
              size="secondary"
              w={{ mobile: 'full', tablet: 'fit-content' }}
              onClick={onAccept}
            >
              Подтверждаю
            </Button>
          </Stack>
        </Wrapper>
      </Flex>
    )
  );
};

export default memo(Cookies);
